const indexItems = [
  { id: 1, label: '韩漫大全', icon: 'ri-heart-pulse-line', count: '856部', color: 'primary' },
  { id: 2, label: '日漫精选', icon: 'ri-sun-foggy-line', count: '1203部', color: 'accent' },
  { id: 3, label: '国漫专区', icon: 'ri-flag-2-fill', count: '689部', color: 'secondary' },
  { id: 4, label: '恋爱言情', icon: 'ri-heart-3-line', count: '432部', color: 'primary' },
  { id: 5, label: '玄幻修仙', icon: 'ri-moon-foggy-line', count: '378部', color: 'accent' },
  { id: 6, label: '校园日常', icon: 'ri-building-2-line', count: '296部', color: 'secondary' },
  { id: 7, label: '悬疑推理', icon: 'ri-search-eye-line', count: '215部', color: 'primary' },
  { id: 8, label: '耽美百合', icon: 'ri-flower-line', count: '187部', color: 'accent' },
];

const colorMap: Record<string, { bg: string; text: string; border: string; hover: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-500', border: 'hover:border-primary-200', hover: 'hover:bg-primary-50' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-500', border: 'hover:border-accent-200', hover: 'hover:bg-accent-50' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-500', border: 'hover:border-secondary-200', hover: 'hover:bg-secondary-50' },
};

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
            <i className="ri-folder-2-line text-secondary-500 text-xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">分类索引</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-[52px]">八大分类，快速找到你想看的漫画类型</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {indexItems.map((item) => {
            const c = colorMap[item.color];
            return (
              <div
                key={item.id}
                className={`group flex flex-col items-center gap-3 p-6 rounded-2xl bg-background-100 border border-background-200/70 ${c.border} ${c.hover} transition-all duration-200 cursor-pointer`}
              >
                <div className={`w-14 h-14 rounded-2xl ${c.bg} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                  <i className={`${item.icon} ${c.text} text-2xl`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.label}</h3>
                <span className="text-xs text-foreground-500 bg-background-200/50 px-3 py-1 rounded-full whitespace-nowrap">{item.count}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}